import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=0040b370&scoped=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"
import style0 from "./Header.vue?vue&type=style&index=0&id=0040b370&prod&scoped=true&lang=less"
import style1 from "./Header.vue?vue&type=style&index=1&id=0040b370&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0040b370",
  null
  
)

export default component.exports